define('model/DayModel',['require','lib/model/BaseModel'],function (require) {
	
	var BaseModel = require('lib/model/BaseModel');
	
	/**
	 * Day info model
	 * 
	 * @class DayModel
	 */
	return BaseModel.extend({
		
		defaults: {
			id: '',
			date: '',
			time: [],
			is_day_off: false
		},
		
		initialize: function (options) {
			if (options && options.url) {
				this.url = options.url;
			}
			
			BaseModel.prototype.initialize.call(this);
		}
	
	});
	
});
